"use strict";

let i = 1;

let home = document.querySelector('.home');
let produit = document.querySelector('.produitL');
let panier = document.querySelector('.panier');
let livraison = document.querySelector('.livraison');
let paiement = document.querySelector('.paiement');
let recapitulatif = document.querySelector('.recapitulatifL');
let confirmation = document.querySelector('.confirmation');

if(produit){

    sessionStorage.setItem('quantite', 1);

    //button
    let langue = document.querySelector('.langue');
    let languebtn = document.querySelector('#langues');
    let mainPorduit = document.querySelector('.mainProduit');
    languebtn.addEventListener('click', buttonLangue);
    function buttonLangue(){
        langue.classList.toggle('hide');
        mainPorduit.classList.toggle('mainProduit--sanslangue');
    } 

    //ajoutPanier1
    //prix
    let prixn = document.querySelector('#prixN');
    let prixp = document.querySelector('#prixP');
    //choix version
    let achatBtnPhysique = document.querySelector('#btnp');
    let achatBtnNumerique = document.querySelector('#btnn');
    achatBtnPhysique.addEventListener('click', choixVersion);
    achatBtnNumerique.addEventListener('click', choixVersion);
    function choixVersion(){
        let achatPhysique = document.querySelector('.achatlist__el--physique');
        let achatNumerique = document.querySelector('.achatlist__el--numerique');

        if(achatBtnPhysique.classList.contains('buttonAchatActif')){
            achatBtnPhysique.classList.remove('buttonAchatActif');
            achatBtnNumerique.classList.add('buttonAchatActif');
            achatNumerique.classList.remove('hide');
            achatPhysique.classList.add('hide');
            i = 1
            quantiteP.innerHTML = i;
            quantiteN.innerHTML = i;
            prixn.innerHTML = i*2.99 + "&nbsp;€";
            prixp.innerHTML = i*2.99 + "&nbsp;€";
            sessionStorage.setItem('quantite', i);
        }else{
            achatBtnPhysique.classList.add('buttonAchatActif');
            achatBtnNumerique.classList.remove('buttonAchatActif');
            achatNumerique.classList.add('hide');
            achatPhysique.classList.remove('hide');
            i = 1
            quantiteP.innerHTML = i;
            quantiteN.innerHTML = i;
            prixn.innerHTML = i*2.99 + "&nbsp;€";
            prixp.innerHTML = i*13.99 + "&nbsp;€";
            sessionStorage.setItem('quantite', i);
        }
    }
    //quantite
    let btnPlusP = document.querySelector('.btnPlusP');
    let btnMoinsP = document.querySelector('.btnMoinsP');
    let btnPlusN = document.querySelector('.btnPlusN');
    let btnMoinsN = document.querySelector('.btnMoinsN');
    let quantiteP = document.querySelector('.quantite__el--qp');
    let quantiteN = document.querySelector('.quantite__el--qn');
    btnPlusP.addEventListener('click', quantitePlus);
    btnMoinsP.addEventListener('click', quantiteMoins);
    btnPlusN.addEventListener('click', quantitePlus);
    btnMoinsN.addEventListener('click', quantiteMoins);
    function quantitePlus(){ 
        i= i+1;
    quantiteP.innerHTML = i;
    quantiteN.innerHTML = i;
    prixn.innerHTML = Math.round((i*2.99)*100)/100+ "&nbsp;€";
    prixp.innerHTML = Math.round((i*13.99)*100)/100 + "&nbsp;€";
    sessionStorage.setItem('quantite', i);
    }
    function quantiteMoins(){
        if (i>1){
            i= i-1;
        } 
    quantiteP.innerHTML = i;
    quantiteN.innerHTML = i;
    prixn.innerHTML = Math.round((i*2.99)*100)/100 + "&nbsp;€";
    prixp.innerHTML = Math.round((i*13.99)*100)/100 + "&nbsp;€";
    sessionStorage.setItem('quantite', i);
    }
    //ajout
    let buttonAjout = document.querySelector(".buttonAjouterpanier");
    buttonAjout.addEventListener('click', panierp);
    function panierp(){
        if(achatBtnNumerique.classList.contains('buttonAchatActif')){
            sessionStorage.setItem('numerique', '1');
        } else if(achatBtnPhysique.classList.contains('buttonAchatActif')){
            sessionStorage.setItem('physique', '1');
        }
    }





    //ajoutPanier2
    //prix
    let prixn2 = document.querySelector('#prixN2');
    let prixp2 = document.querySelector('#prixP2');
    //choix version
    let achatBtnPhysique2 = document.querySelector('#btnp2');
    let achatBtnNumerique2 = document.querySelector('#btnn2');
    achatBtnPhysique2.addEventListener('click', choixVersion2);
    achatBtnNumerique2.addEventListener('click', choixVersion2);
    function choixVersion2(){
        let achatPhysique2 = document.querySelector('.achatlist__el--physique2');
        let achatNumerique2 = document.querySelector('.achatlist__el--numerique2');

        if(achatBtnPhysique2.classList.contains('buttonAchatActif')){
            achatBtnPhysique2.classList.remove('buttonAchatActif');
            achatBtnNumerique2.classList.add('buttonAchatActif');
            achatNumerique2.classList.remove('hide');
            achatPhysique2.classList.add('hide');
            i = 1
            quantiteP2.innerHTML = i;
            quantiteN2.innerHTML = i;
            prixn2.innerHTML = i*2.99 + "&nbsp;€";
            prixp2.innerHTML = i*2.99 + "&nbsp;€";
            sessionStorage.setItem('quantite', i);
        }else{
            achatBtnPhysique2.classList.add('buttonAchatActif');
            achatBtnNumerique2.classList.remove('buttonAchatActif');
            achatNumerique2.classList.add('hide');
            achatPhysique2.classList.remove('hide');
            i = 1
            quantiteP2.innerHTML = i;
            quantiteN2.innerHTML = i;
            prixn2.innerHTML = i*2.99 + "&nbsp;€";
            prixp2.innerHTML = i*13.99 + "&nbsp;€";
            sessionStorage.setItem('quantite', i);
        }
    }
    //quantite
    let btnPlusP2 = document.querySelector('.btnPlusP2');
    let btnMoinsP2 = document.querySelector('.btnMoinsP2');
    let btnPlusN2 = document.querySelector('.btnPlusN2');
    let btnMoinsN2 = document.querySelector('.btnMoinsN2');
    let quantiteP2 = document.querySelector('.quantite__el--qp2');
    let quantiteN2 = document.querySelector('.quantite__el--qn2');
    btnPlusP2.addEventListener('click', quantitePlus2);
    btnMoinsP2.addEventListener('click', quantiteMoins2);
    btnPlusN2.addEventListener('click', quantitePlus2);
    btnMoinsN2.addEventListener('click', quantiteMoins2);
    function quantitePlus2(){ 
        i= i+1;
    quantiteP2.innerHTML = i;
    quantiteN2.innerHTML = i;
    prixn2.innerHTML = Math.round((i*2.99)*100)/100+ "&nbsp;€";
    prixp2.innerHTML = Math.round((i*13.99)*100)/100 + "&nbsp;€";
    sessionStorage.setItem('quantite', i);
    }
    function quantiteMoins2(){
        if (i>1){
            i= i-1;
        } 
    quantiteP2.innerHTML = i;
    quantiteN2.innerHTML = i;
    prixn2.innerHTML = Math.round((i*2.99)*100)/100 + "&nbsp;€";
    prixp2.innerHTML = Math.round((i*13.99)*100)/100 + "&nbsp;€";
    sessionStorage.setItem('quantite', i);
    }
    //ajout
    let buttonAjout2 = document.querySelector(".buttonAjouterpanier2");
    buttonAjout2.addEventListener('click', panierp2);
    function panierp2(){
        if(achatBtnNumerique2.classList.contains('buttonAchatActif')){
            sessionStorage.setItem('numerique', '1');
        } else if(achatBtnPhysique2.classList.contains('buttonAchatActif')){
            sessionStorage.setItem('physique', '1');
        }
    }
} 

else if(home){
    sessionStorage.setItem('iin', '1');
    sessionStorage.setItem('iip', '1');


    //voirPlus-sliderAvis
    let voirPlusPlus = document.querySelector(".buttonVoirPlus--plus");
    let voirPlus = document.querySelector(".buttonVoirPlus");
    let avisHidden = document.querySelector(".sl5__slide--hidden");

    voirPlus.addEventListener("click", voirPlusFct); 
    window.addEventListener('resize', changementAvis);

    function voirPlusFct(){
            avisHidden.classList.toggle("sl5__slide--hidden");

        if(voirPlusPlus.classList.contains('buttonVoirPlus--plus')){
            voirPlusPlus.classList.remove('buttonVoirPlus--plus');
            voirPlusPlus.classList.add('buttonVoirPlus--moins');
            voirPlus.innerHTML = "Voir Moins";
        }else{
            voirPlusPlus.classList.add('buttonVoirPlus--plus');
            voirPlusPlus.classList.remove('buttonVoirPlus--moins');
            voirPlus.innerHTML = "Voir Plus";
        }   
    }
    function changementAvis(){
        if (window.matchMedia("(min-width: 1210px)").matches) {
            avisHidden.classList.add("sl5__slide--hidden");
            voirPlusPlus.classList.add('buttonVoirPlus--plus');
            voirPlusPlus.classList.remove('buttonVoirPlus--moins');
            voirPlus.innerHTML = "Voir Plus";
        }
    }

    let prevButton = document.querySelector(".slider__button--left");
    let nextButton = document.querySelector(".slider__button--right");
    let i = 1;

    prevButton.addEventListener("click", prevSlide);
    nextButton.addEventListener("click", nextSlide);
    document.addEventListener("keydown", keyboardListener);

    function keyboardListener(event){
        if(event.code == "ArrowLeft"){
            prevSlide();
        }else if(event.code == "ArrowRight"){
            nextSlide();
        }
    }
    function prevSlide(){
        let activeSlideEl = document.querySelector(".sl5__slide--hidden");
        let prevSlideEl = activeSlideEl.previousElementSibling;
        let indic = document.querySelector(".slider__el--indic");

        if(!prevSlideEl){
            prevSlideEl = activeSlideEl.parentNode.lastElementChild;
        }
        activeSlideEl.classList.remove("sl5__slide--hidden");
        prevSlideEl.classList.add("sl5__slide--hidden");

        
        i = i - 1;
        if (i==0){
            i = 2;
        } 
        indic.innerHTML = i + "/2";   
    }
    function nextSlide(){
        let activeSlideEl = document.querySelector(".sl5__slide--hidden");
        let nextSlideEl = activeSlideEl.nextElementSibling;
        let indic = document.querySelector(".slider__el--indic");
        
        if(!nextSlideEl){
            nextSlideEl = activeSlideEl.parentNode.firstElementChild;
        }
        activeSlideEl.classList.remove("sl5__slide--hidden");
        nextSlideEl.classList.add("sl5__slide--hidden");

        i = i + 1;
        if (i==3){
            i = 1;
        } 
        indic.innerHTML = i + "/2";
    }

    //presse-personnel
    let ulpresse = document.querySelector('.sl5__presse');
    let ulperso = document.querySelector('.sl5__avis');

    let perso = document.querySelector('.buttonPerso');
    let presse = document.querySelector('.buttonPresse');

    presse.addEventListener('click', change);
    perso.addEventListener('click', change);

    function change(){
        let sliderButton = document.querySelector('.sl5__slider');

        if (ulpresse.classList.contains('hide')){
            sliderButton.classList.add('hide');
            voirPlus.classList.add('hide');

            ulpresse.classList.remove('hide');
            ulperso.classList.add('hide');
            perso.classList.remove('buttonAvisActif');
            presse.classList.add('buttonAvisActif');
            
            for(let i = 0; i < avisHidden.length; i++){
                avisHidden[i].classList.add("hide");
            }
        }else{
            sliderButton.classList.remove('hide');
            voirPlus.classList.remove('hide');

            ulpresse.classList.add('hide');
            ulperso.classList.remove('hide');
            perso.classList.add('buttonAvisActif');
            presse.classList.remove('buttonAvisActif');
            
            for(let i = 0; i < avisHidden.length; i++){
                avisHidden[i].classList.add("hide");
            }
        }
    }
    
    //sliderPersonnages
    let prevBtn = document.querySelector(".slider__button--prev");
    let nextBtn = document.querySelector(".slider__button--next");
    let ii = 1;

    prevBtn.addEventListener("click", prevPerso);
    nextBtn.addEventListener("click", nextPerso);
    document.addEventListener("keydown", keyboardListener2);

    function keyboardListener2(event){
        if(event.code == "ArrowLeft"){
            prevPerso();
        }else if(event.code == "ArrowRight"){
            nextPerso();
        }
    }
    function prevPerso(){
        let activePersoEl = document.querySelector(".slider__el--show");
        let prevPersoEl = activePersoEl.previousElementSibling;
        let indicateur = document.querySelector(".slider__el--indicateur");

        if(!prevPersoEl){
            prevPersoEl = activePersoEl.parentNode.lastElementChild;
        }
        activePersoEl.classList.add("slider__el--hidden");
        activePersoEl.classList.remove("slider__el--show");
        prevPersoEl.classList.remove("slider__el--hidden");
        prevPersoEl.classList.add("slider__el--show");

        ii = ii - 1;
        if (ii==0){
            ii = 5;
        } 
        indicateur.innerHTML = ii + "/5";  

        
    }
    function nextPerso(){
        let activePersoEl = document.querySelector(".slider__el--show");
        let nextPersoEl = activePersoEl.nextElementSibling;
        let indicateur = document.querySelector(".slider__el--indicateur");
        
        if(!nextPersoEl){
            nextPersoEl = activePersoEl.parentNode.firstElementChild;
        }
        activePersoEl.classList.add("slider__el--hidden");
        activePersoEl.classList.remove("slider__el--show");
        nextPersoEl.classList.remove("slider__el--hidden");
        nextPersoEl.classList.add("slider__el--show");

        
        ii = ii + 1;
        if (ii==6){
            ii = 1;
        } 
        indicateur.innerHTML = ii + "/5"; 
        }
        
    //mind
    let image = document.querySelectorAll(".images__el");
    let image1 = document.querySelector(".images__el--1");
    let image2 = document.querySelector(".images__el--2");
    let image3 = document.querySelector(".images__el--3");
    let image4 = document.querySelector(".images__el--4");
    let image5 = document.querySelector(".images__el--5");
    let image6 = document.querySelector(".images__el--6");
    let image7 = document.querySelector(".images__el--7");
    let image8 = document.querySelector(".images__el--8");
    let image9 = document.querySelector(".images__el--9");
    let image10 = document.querySelector(".images__el--10");
    let image11 = document.querySelector(".images__el--11");
    let image12 = document.querySelector(".images__el--12");
    let image13 = document.querySelector(".images__el--13");
    let image14 = document.querySelector(".images__el--14");
    let image15 = document.querySelector(".images__el--15");
    let image16 = document.querySelector(".images__el--16");
    let image17 = document.querySelector(".images__el--17");
    let image18 = document.querySelector(".images__el--18");
    let image19 = document.querySelector(".images__el--19");
    let image20 = document.querySelector(".images__el--20");
    let image21 = document.querySelector(".images__el--21");
    let image22 = document.querySelector(".images__el--22");
    let image23 = document.querySelector(".images__el--23");
    let image24 = document.querySelector(".images__el--24");
    let image25 = document.querySelector(".images__el--25");
    let image26 = document.querySelector(".images__el--26");
    let image27 = document.querySelector(".images__el--27");
    let image28 = document.querySelector(".images__el--28");
    let image29 = document.querySelector(".images__el--29");
    let image30 = document.querySelector(".images__el--30");
    let image31 = document.querySelector(".images__el--31");
    let image32 = document.querySelector(".images__el--32");
    let button1 = document.querySelector(".svg__point--1");
    let button2 = document.querySelector(".svg__point--2");
    let button3 = document.querySelector(".svg__point--3");
    let button4 = document.querySelector(".svg__point--4");
    let button5 = document.querySelector(".svg__point--5");
    let button6 = document.querySelector(".svg__point--6");
    let button7 = document.querySelector(".svg__point--7");
    let button8 = document.querySelector(".svg__point--8");
    let button9 = document.querySelector(".svg__point--9");
    let button10 = document.querySelector(".svg__point--10");
    let button11 = document.querySelector(".svg__point--11");
    let button12 = document.querySelector(".svg__point--12");
    let button13 = document.querySelector(".svg__point--13");
    let button14 = document.querySelector(".svg__point--14");
    let button15 = document.querySelector(".svg__point--15");
    let button16 = document.querySelector(".svg__point--16");
    let button17 = document.querySelector(".svg__point--17");
    let button18 = document.querySelector(".svg__point--18");
    let button19 = document.querySelector(".svg__point--19");
    let button20 = document.querySelector(".svg__point--20");
    let button21 = document.querySelector(".svg__point--21");
    let button22 = document.querySelector(".svg__point--22");
    let button23 = document.querySelector(".svg__point--23");
    let button24 = document.querySelector(".svg__point--24");
    let button25 = document.querySelector(".svg__point--25");
    let button26 = document.querySelector(".svg__point--26");
    let button27 = document.querySelector(".svg__point--27");
    let button28 = document.querySelector(".svg__point--28");
    let button29 = document.querySelector(".svg__point--29");
    let button30 = document.querySelector(".svg__point--30");
    let button31 = document.querySelector(".svg__point--31");
    let button32 = document.querySelector(".svg__point--32");
    let pt1 = document.querySelector(".svg__ptpath--1");
    let pt2 = document.querySelector(".svg__ptpath--2");
    let pt3 = document.querySelector(".svg__ptpath--3");
    let pt4 = document.querySelector(".svg__ptpath--4");
    let pt5 = document.querySelector(".svg__ptpath--5");
    let pt6 = document.querySelector(".svg__ptpath--6");
    let pt7 = document.querySelector(".svg__ptpath--7");
    let pt8 = document.querySelector(".svg__ptpath--8");
    let pt9 = document.querySelector(".svg__ptpath--9");
    let pt10 = document.querySelector(".svg__ptpath--10");
    let pt11 = document.querySelector(".svg__ptpath--11");
    let pt12 = document.querySelector(".svg__ptpath--12");
    let pt13 = document.querySelector(".svg__ptpath--13");
    let pt14 = document.querySelector(".svg__ptpath--14");
    let pt15 = document.querySelector(".svg__ptpath--15");
    let pt16 = document.querySelector(".svg__ptpath--16");
    let pt17 = document.querySelector(".svg__ptpath--17");
    let pt18 = document.querySelector(".svg__ptpath--18");
    let pt19 = document.querySelector(".svg__ptpath--19");
    let pt20 = document.querySelector(".svg__ptpath--20");
    let pt21 = document.querySelector(".svg__ptpath--21");
    let pt22 = document.querySelector(".svg__ptpath--22");
    let pt23 = document.querySelector(".svg__ptpath--23");
    let pt24 = document.querySelector(".svg__ptpath--24");
    let pt25 = document.querySelector(".svg__ptpath--25");
    let pt26 = document.querySelector(".svg__ptpath--26");
    let pt27 = document.querySelector(".svg__ptpath--27");
    let pt28 = document.querySelector(".svg__ptpath--28");
    let pt29 = document.querySelector(".svg__ptpath--29");
    let pt30 = document.querySelector(".svg__ptpath--30");
    let pt31 = document.querySelector(".svg__ptpath--31");
    let pt32 = document.querySelector(".svg__ptpath--32");

    button1.addEventListener("click", img1);
    button2.addEventListener("click", img2);
    button3.addEventListener("click", img3);
    button4.addEventListener("click", img4);
    button5.addEventListener("click", img5);
    button6.addEventListener("click", img6);
    button7.addEventListener("click", img7);
    button8.addEventListener("click", img8);
    button9.addEventListener("click", img9);
    button10.addEventListener("click", img10);
    button11.addEventListener("click", img11);
    button12.addEventListener("click", img12);
    button13.addEventListener("click", img13);
    button14.addEventListener("click", img14);
    button15.addEventListener("click", img15);
    button16.addEventListener("click", img16);
    button17.addEventListener("click", img17);
    button18.addEventListener("click", img18);
    button19.addEventListener("click", img19);
    button20.addEventListener("click", img20);
    button21.addEventListener("click", img21);
    button22.addEventListener("click", img22);
    button23.addEventListener("click", img23);
    button24.addEventListener("click", img24);
    button25.addEventListener("click", img25);
    button26.addEventListener("click", img26);
    button27.addEventListener("click", img27);
    button28.addEventListener("click", img28);
    button29.addEventListener("click", img29);
    button30.addEventListener("click", img30);
    button31.addEventListener("click", img31);
    button32.addEventListener("click", img32);

    function img1(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image1.classList.toggle("hide");
        pt1.classList.add("svg__ptpath--actif");
    }
    function img2(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image2.classList.toggle("hide");
        pt2.classList.add("svg__ptpath--actif");
    }
    function img3(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image3.classList.toggle("hide");
        pt3.classList.add("svg__ptpath--actif");
    }
    function img4(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image4.classList.toggle("hide");
        pt4.classList.add("svg__ptpath--actif");
    }
    function img5(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image5.classList.toggle("hide");
        pt5.classList.add("svg__ptpath--actif");
    }
    function img6(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image6.classList.toggle("hide");
        pt6.classList.add("svg__ptpath--actif");
    }
    function img7(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image7.classList.toggle("hide");
        pt7.classList.add("svg__ptpath--actif");
    }
    function img8(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image8.classList.toggle("hide");
        pt8.classList.add("svg__ptpath--actif");
    }
    function img9(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image9.classList.toggle("hide");
        pt9.classList.add("svg__ptpath--actif");
    }
    function img10(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image10.classList.toggle("hide");
        pt10.classList.add("svg__ptpath--actif");
    }
    function img11(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image11.classList.toggle("hide");
        pt11.classList.add("svg__ptpath--actif");
    }
    function img12(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image12.classList.toggle("hide");
        pt12.classList.add("svg__ptpath--actif");
    }
    function img13(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image13.classList.toggle("hide");
        pt13.classList.add("svg__ptpath--actif");
    }
    function img14(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image14.classList.toggle("hide");
        pt14.classList.add("svg__ptpath--actif");
    }
    function img15(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image15.classList.toggle("hide");
        pt15.classList.add("svg__ptpath--actif");
    }
    function img16(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image16.classList.toggle("hide");
        pt16.classList.add("svg__ptpath--actif");
    }
    function img17(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image17.classList.toggle("hide");
        pt17.classList.add("svg__ptpath--actif");
    }
    function img18(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image18.classList.toggle("hide");
        pt18.classList.add("svg__ptpath--actif");
    }
    function img19(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image19.classList.toggle("hide");
        pt19.classList.add("svg__ptpath--actif");
    }
    function img20(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image20.classList.toggle("hide");
        pt20.classList.add("svg__ptpath--actif");
    }
    function img21(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image21.classList.toggle("hide");
        pt21.classList.add("svg__ptpath--actif");
    }
    function img22(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image22.classList.toggle("hide");
        pt22.classList.add("svg__ptpath--actif");
    }
    function img23(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image23.classList.toggle("hide");
        pt23.classList.add("svg__ptpath--actif");
    }
    function img24(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image24.classList.toggle("hide");
        pt24.classList.add("svg__ptpath--actif");
    }
    function img25(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image25.classList.toggle("hide");
        pt25.classList.add("svg__ptpath--actif");
    }
    function img26(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image26.classList.toggle("hide");
        pt26.classList.add("svg__ptpath--actif");
    }
    function img27(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image27.classList.toggle("hide");
        pt27.classList.add("svg__ptpath--actif");
    }
    function img28(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image28.classList.toggle("hide");
        pt28.classList.add("svg__ptpath--actif");
    }
    function img29(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image29.classList.toggle("hide");
        pt29.classList.add("svg__ptpath--actif");
    }
    function img30(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image30.classList.toggle("hide");
        pt30.classList.add("svg__ptpath--actif");
    }
    function img31(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image31.classList.toggle("hide");
        pt31.classList.add("svg__ptpath--actif");
    }
    function img32(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image32.classList.toggle("hide");
        pt32.classList.add("svg__ptpath--actif");
    }

    //mind mobile
    let button1mobile = document.querySelector(".svg__pointmobile--1");
    let button2mobile = document.querySelector(".svg__pointmobile--2");
    let button3mobile = document.querySelector(".svg__pointmobile--3");
    let button4mobile = document.querySelector(".svg__pointmobile--4");
    let button5mobile = document.querySelector(".svg__pointmobile--5");
    let button6mobile = document.querySelector(".svg__pointmobile--6");
    let button7mobile = document.querySelector(".svg__pointmobile--7");
    let button8mobile = document.querySelector(".svg__pointmobile--8");
    let button9mobile = document.querySelector(".svg__pointmobile--9");
    let button10mobile = document.querySelector(".svg__pointmobile--10");
    let button11mobile = document.querySelector(".svg__pointmobile--11");
    let button12mobile = document.querySelector(".svg__pointmobile--12");
    let button13mobile = document.querySelector(".svg__pointmobile--13");
    let button14mobile = document.querySelector(".svg__pointmobile--14");
    let button15mobile = document.querySelector(".svg__pointmobile--15");
    let button16mobile = document.querySelector(".svg__pointmobile--16");
    let button17mobile = document.querySelector(".svg__pointmobile--17");
    let button18mobile = document.querySelector(".svg__pointmobile--18");
    let button19mobile = document.querySelector(".svg__pointmobile--19");
    let button20mobile = document.querySelector(".svg__pointmobile--20");
    let button21mobile = document.querySelector(".svg__pointmobile--21");
    let button22mobile = document.querySelector(".svg__pointmobile--22");
    let button23mobile = document.querySelector(".svg__pointmobile--23");
    let button24mobile = document.querySelector(".svg__pointmobile--24");
    let button25mobile = document.querySelector(".svg__pointmobile--25");
    let button26mobile = document.querySelector(".svg__pointmobile--26");
    let button27mobile = document.querySelector(".svg__pointmobile--27");
    let button28mobile = document.querySelector(".svg__pointmobile--28");
    let button29mobile = document.querySelector(".svg__pointmobile--29");
    let button30mobile = document.querySelector(".svg__pointmobile--30");
    let button31mobile = document.querySelector(".svg__pointmobile--31");
    let button32mobile = document.querySelector(".svg__pointmobile--32");
    let pt1mobile = document.querySelector(".svg__ptpathmobile--1");
    let pt2mobile = document.querySelector(".svg__ptpathmobile--2");
    let pt3mobile = document.querySelector(".svg__ptpathmobile--3");
    let pt4mobile = document.querySelector(".svg__ptpathmobile--4");
    let pt5mobile = document.querySelector(".svg__ptpathmobile--5");
    let pt6mobile = document.querySelector(".svg__ptpathmobile--6");
    let pt7mobile = document.querySelector(".svg__ptpathmobile--7");
    let pt8mobile = document.querySelector(".svg__ptpathmobile--8");
    let pt9mobile = document.querySelector(".svg__ptpathmobile--9");
    let pt10mobile = document.querySelector(".svg__ptpathmobile--10");
    let pt11mobile = document.querySelector(".svg__ptpathmobile--11");
    let pt12mobile = document.querySelector(".svg__ptpathmobile--12");
    let pt13mobile = document.querySelector(".svg__ptpathmobile--13");
    let pt14mobile = document.querySelector(".svg__ptpathmobile--14");
    let pt15mobile = document.querySelector(".svg__ptpathmobile--15");
    let pt16mobile = document.querySelector(".svg__ptpathmobile--16");
    let pt17mobile = document.querySelector(".svg__ptpathmobile--17");
    let pt18mobile = document.querySelector(".svg__ptpathmobile--18");
    let pt19mobile = document.querySelector(".svg__ptpathmobile--19");
    let pt20mobile = document.querySelector(".svg__ptpathmobile--20");
    let pt21mobile = document.querySelector(".svg__ptpathmobile--21");
    let pt22mobile = document.querySelector(".svg__ptpathmobile--22");
    let pt23mobile = document.querySelector(".svg__ptpathmobile--23");
    let pt24mobile = document.querySelector(".svg__ptpathmobile--24");
    let pt25mobile = document.querySelector(".svg__ptpathmobile--25");
    let pt26mobile = document.querySelector(".svg__ptpathmobile--26");
    let pt27mobile = document.querySelector(".svg__ptpathmobile--27");
    let pt28mobile = document.querySelector(".svg__ptpathmobile--28");
    let pt29mobile = document.querySelector(".svg__ptpathmobile--29");
    let pt30mobile = document.querySelector(".svg__ptpathmobile--30");
    let pt31mobile = document.querySelector(".svg__ptpathmobile--31");
    let pt32mobile = document.querySelector(".svg__ptpathmobile--32");

    button1mobile.addEventListener("click", img1mobile);
    button2mobile.addEventListener("click", img2mobile);
    button3mobile.addEventListener("click", img3mobile);
    button4mobile.addEventListener("click", img4mobile);
    button5mobile.addEventListener("click", img5mobile);
    button6mobile.addEventListener("click", img6mobile);
    button7mobile.addEventListener("click", img7mobile);
    button8mobile.addEventListener("click", img8mobile);
    button9mobile.addEventListener("click", img9mobile);
    button10mobile.addEventListener("click", img10mobile);
    button11mobile.addEventListener("click", img11mobile);
    button12mobile.addEventListener("click", img12mobile);
    button13mobile.addEventListener("click", img13mobile);
    button14mobile.addEventListener("click", img14mobile);
    button15mobile.addEventListener("click", img15mobile);
    button16mobile.addEventListener("click", img16mobile);
    button17mobile.addEventListener("click", img17mobile);
    button18mobile.addEventListener("click", img18mobile);
    button19mobile.addEventListener("click", img19mobile);
    button20mobile.addEventListener("click", img20mobile);
    button21mobile.addEventListener("click", img21mobile);
    button22mobile.addEventListener("click", img22mobile);
    button23mobile.addEventListener("click", img23mobile);
    button24mobile.addEventListener("click", img24mobile);
    button25mobile.addEventListener("click", img25mobile);
    button26mobile.addEventListener("click", img26mobile);
    button27mobile.addEventListener("click", img27mobile);
    button28mobile.addEventListener("click", img28mobile);
    button29mobile.addEventListener("click", img29mobile);
    button30mobile.addEventListener("click", img30mobile);
    button31mobile.addEventListener("click", img31mobile);
    button32mobile.addEventListener("click", img32mobile);

    function img1mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image1.classList.toggle("hide");
        pt1mobile.classList.add("svg__ptpath--actif");
    }
    function img2mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image2.classList.toggle("hide");
        pt2mobile.classList.add("svg__ptpath--actif");
    }
    function img3mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image3.classList.toggle("hide");
        pt3mobile.classList.add("svg__ptpath--actif");
    }
    function img4mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image4.classList.toggle("hide");
        pt4mobile.classList.add("svg__ptpath--actif");
    }
    function img5mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image5.classList.toggle("hide");
        pt5mobile.classList.add("svg__ptpath--actif");
    }
    function img6mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image6.classList.toggle("hide");
        pt6mobile.classList.add("svg__ptpath--actif");
    }
    function img7mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image7.classList.toggle("hide");
        pt7mobile.classList.add("svg__ptpath--actif");
    }
    function img8mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image8.classList.toggle("hide");
        pt8mobile.classList.add("svg__ptpath--actif");
    }
    function img9mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image9.classList.toggle("hide");
        pt9mobile.classList.add("svg__ptpath--actif");
    }
    function img10mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image10.classList.toggle("hide");
        pt10mobile.classList.add("svg__ptpath--actif");
    }
    function img11mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image11.classList.toggle("hide");
        pt11mobile.classList.add("svg__ptpath--actif");
    }
    function img12mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image12.classList.toggle("hide");
        pt12mobile.classList.add("svg__ptpath--actif");
    }
    function img13mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image13.classList.toggle("hide");
        pt13mobile.classList.add("svg__ptpath--actif");
    }
    function img14mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image14.classList.toggle("hide");
        pt14mobile.classList.add("svg__ptpath--actif");
    }
    function img15mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image15.classList.toggle("hide");
        pt15mobile.classList.add("svg__ptpath--actif");
    }
    function img16mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image16.classList.toggle("hide");
        pt16mobile.classList.add("svg__ptpath--actif");
    }
    function img17mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image17.classList.toggle("hide");
        pt17mobile.classList.add("svg__ptpath--actif");
    }
    function img18mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image18.classList.toggle("hide");
        pt18mobile.classList.add("svg__ptpath--actif");
    }
    function img19mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image19.classList.toggle("hide");
        pt19mobile.classList.add("svg__ptpath--actif");
    }
    function img20mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image20.classList.toggle("hide");
        pt20mobile.classList.add("svg__ptpath--actif");
    }
    function img21mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image21.classList.toggle("hide");
        pt21mobile.classList.add("svg__ptpath--actif");
    }
    function img22mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image22.classList.toggle("hide");
        pt22mobile.classList.add("svg__ptpath--actif");
    }
    function img23mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image23.classList.toggle("hide");
        pt23mobile.classList.add("svg__ptpath--actif");
    }
    function img24mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image24.classList.toggle("hide");
        pt24mobile.classList.add("svg__ptpath--actif");
    }
    function img25mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image25.classList.toggle("hide");
        pt25mobile.classList.add("svg__ptpath--actif");
    }
    function img26mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image26.classList.toggle("hide");
        pt26mobile.classList.add("svg__ptpath--actif");
    }
    function img27mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image27.classList.toggle("hide");
        pt27mobile.classList.add("svg__ptpath--actif");
    }
    function img28mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image28.classList.toggle("hide");
        pt28mobile.classList.add("svg__ptpath--actif");
    }
    function img29mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image29.classList.toggle("hide");
        pt29mobile.classList.add("svg__ptpath--actif");
    }
    function img30mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image30.classList.toggle("hide");
        pt30mobile.classList.add("svg__ptpath--actif");
    }
    function img31mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image31.classList.toggle("hide");
        pt31mobile.classList.add("svg__ptpath--actif");
    }
    function img32mobile(){
        for(let i = 0; i < image.length; i++){
            image[i].classList.add("hide");
        }
        image32.classList.toggle("hide");
        pt32mobile.classList.add("svg__ptpath--actif");
    }
}

else if(panier){
    //articles
    let produitNum = document.querySelector('.produitpanier--numerique');
    let produitPhys = document.querySelector('.produitpanier--physique');
    let aucunArticle = document.querySelector('.pasArticle');
    let infosPanier = document.querySelector('.infosPanier');
    let articlePanierNum = sessionStorage.getItem('numerique');
    let articlePanierPhys = sessionStorage.getItem('physique');

    
    let i = Number(sessionStorage.getItem('quantite'));
    console.log(i);
    

    //Recap - voir code promo et quantite
    let quantiteFinale = document.querySelector('#prixArticle');
    let prixPromo = document.querySelector('#prixPromo');
    let total = document.querySelector('#total');


    //quantite
    let btnPlusP = document.querySelector('.btnPlusP');
    let btnMoinsP = document.querySelector('.btnMoinsP');
    let btnPlusN = document.querySelector('.btnPlusN');
    let btnMoinsN = document.querySelector('.btnMoinsN');
    let quantiteP = document.querySelector('.quantitePhys');
    let quantiteN = document.querySelector('.quantiteNum');
    let prixn = document.querySelector('.prixpanierNum');
    let prixp = document.querySelector('.prixpanierPhys');

    btnPlusP.addEventListener('click', quantitePlus);
    btnMoinsP.addEventListener('click', quantiteMoins);
    btnPlusN.addEventListener('click', quantitePlus);
    btnMoinsN.addEventListener('click', quantiteMoins);


    let iip = i;
    let iin = i;
    if(articlePanierNum == "1" && articlePanierPhys == "1"){
        iip = 1;
        iin = 1;
    } else {
        iip = i;
        iin= i;
    }

    function quantitePlus(event){ 
        if (event.currentTarget == btnPlusP){
            iip = iip + 1;
            sessionStorage.setItem('iip', iip);
            quantiteP.innerHTML = iip; 
            prixp.innerHTML = Math.round((iip*13.99)*100)/100 + "&nbsp;€";

            
            if(articlePanierPhys=='1' && articlePanierNum=='1'){
                total.innerHTML = Math.round(((iin*2.99)+(iip*13.99))*100)/100 + "&nbsp;€"; 
                quantiteFinale.innerHTML = Math.round(((iin*2.99)+(iip*13.99))*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round(((iin*2.99)+(iip*13.99))*100)/100;
                sessionStorage.setItem('prix', totalsaved);

            } else if(articlePanierNum == '1') {
                total.innerHTML = Math.round((iin*2.99)*100)/100 + "&nbsp;€"; 
                quantiteFinale.innerHTML = Math.round((iin*2.99)*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round((iin*2.99)*100)/100;
                sessionStorage.setItem('prix', totalsaved);
                sessionStorage.setItem('quantite', iin);

            } else {
                total.innerHTML = Math.round((iip*13.99)*100)/100 + "&nbsp;€"; 
                quantiteFinale.innerHTML = Math.round((iip*13.99)*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round((iip*2.99)*100)/100;
                sessionStorage.setItem('prix', totalsaved);
                sessionStorage.setItem('quantite', iip);
            }
            
 
        } else if(event.currentTarget == btnPlusN){
            iin = iin + 1;
            sessionStorage.setItem('iin', iin);
            quantiteN.innerHTML = iin;
            prixn.innerHTML = Math.round((iin*2.99)*100)/100+ "&nbsp;€";

            if(articlePanierPhys=='1' && articlePanierNum=='1'){
                total.innerHTML = Math.round(((iin*2.99)+(iip*13.99))*100)/100 + "&nbsp;€"; 
                quantiteFinale.innerHTML = Math.round(((iin*2.99)+(iip*13.99))*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round(((iin*2.99)+(iip*13.99))*100)/100;
                sessionStorage.setItem('prix', totalsaved);

             } else if(articlePanierNum == '1') {
                total.innerHTML = Math.round((iin*2.99)*100)/100 + "&nbsp;€"; 
                quantiteFinale.innerHTML = Math.round((iin*2.99)*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round((iin*2.99)*100)/100;
                sessionStorage.setItem('prix', totalsaved);
                sessionStorage.setItem('quantite', iin);

             } else {
                total.innerHTML = Math.round((iip*13.99)*100)/100 + "&nbsp;€"; 
                quantiteFinale.innerHTML = Math.round((iip*13.99)*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round((iip*13.99)*100)/100;
                sessionStorage.setItem('prix', totalsaved);
                sessionStorage.setItem('quantite', iip);
             }
             

        }

    }
    function quantiteMoins(event){ 
        if (event.currentTarget == btnMoinsP){
            if (iip>1){
                iip= iip-1;
            } 
            sessionStorage.setItem('iip', iip);
            quantiteP.innerHTML = iip; 
            prixp.innerHTML = Math.round((iip*13.99)*100)/100+ "&nbsp;€";

            if(articlePanierPhys=='1' && articlePanierNum=='1'){
                total.innerHTML = Math.round(((iin*2.99)+(iip*13.99))*100)/100 + "&nbsp;€"; 
                quantiteFinale.innerHTML = Math.round(((iin*2.99)+(iip*13.99))*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round(((iin*2.99)+(iip*13.99))*100)/100;
                sessionStorage.setItem('prix', totalsaved);

             } else if(articlePanierNum == '1') {
                 total.innerHTML = Math.round((iin*2.99)*100)/100 + "&nbsp;€"; 
                 quantiteFinale.innerHTML = Math.round((iin*2.99)*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round((iin*2.99)*100)/100;
                sessionStorage.setItem('prix', totalsaved);
                sessionStorage.setItem('quantite', iin);

             } else {
                 total.innerHTML = Math.round((iip*13.99)*100)/100 + "&nbsp;€"; 
                 quantiteFinale.innerHTML = Math.round((iip*13.99)*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round((iip*13.99)*100)/100;
                sessionStorage.setItem('prix', totalsaved);
                sessionStorage.setItem('quantite', iip);

             }
             


        } else if(event.currentTarget == btnMoinsN){
            if (iin>1){
                iin= iin-1;
            }
            sessionStorage.setItem('iin', iin);
            quantiteN.innerHTML = iin;
            prixn.innerHTML = Math.round((iin*2.99)*100)/100+ "&nbsp;€";

            if(articlePanierPhys=='1' && articlePanierNum=='1'){
                total.innerHTML = Math.round(((iin*2.99)+(iip*13.99))*100)/100 + "&nbsp;€"; 
                quantiteFinale.innerHTML = Math.round(((iin*2.99)+(iip*13.99))*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round(((iin*2.99)+(iip*13.99))*100)/100;
                sessionStorage.setItem('prix', totalsaved);

             } else if(articlePanierNum == '1') {
                 total.innerHTML = Math.round((iin*2.99)*100)/100 + "&nbsp;€"; 
                 quantiteFinale.innerHTML = Math.round((iin*2.99)*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round((iin*2.99)*100)/100;
                sessionStorage.setItem('prix', totalsaved);
                sessionStorage.setItem('quantite', iin);

             } else {
                 total.innerHTML = Math.round((iip*13.99)*100)/100 + "&nbsp;€"; 
                 quantiteFinale.innerHTML = Math.round((iip*13.99)*100)/100 + "&nbsp;€"; 

                let totalsaved = Math.round((iip*13.99)*100)/100;
                sessionStorage.setItem('prix', totalsaved);
                sessionStorage.setItem('quantite', iip);

             }
             
            
        }
    }

    if(articlePanierNum == "1" && articlePanierPhys == "1"){
        produitPhys.classList.remove('hide');
        produitNum.classList.remove('hide');
        infosPanier.classList.remove('hide');
        aucunArticle.classList.add('hide');

        total.innerHTML = Math.round(((1*2.99)+(1*13.99))*100)/100 + "&nbsp;€"; 
        quantiteFinale.innerHTML = Math.round(((1*2.99)+(1*13.99))*100)/100 + "&nbsp;€"; 

        let totalsaved = Math.round(((1*2.99)+(1*13.99))*100)/100;
        sessionStorage.setItem('prix', totalsaved);

    } else if(articlePanierPhys == "1") {
        produitPhys.classList.remove('hide');
        infosPanier.classList.remove('hide');
        aucunArticle.classList.add('hide');
        quantiteP.innerHTML = i;
        prixp.innerHTML = Math.round((i*13.99)*100)/100 + "&nbsp;€";
        total.innerHTML = Math.round((i*13.99)*100)/100 + "&nbsp;€"; 
        quantiteFinale.innerHTML = Math.round((i*13.99)*100)/100 + "&nbsp;€"; 
        let totalsaved = Math.round((i*13.99)*100)/100;
        sessionStorage.setItem('prix', totalsaved);
        

    } else if(articlePanierNum == "1"){
        produitNum.classList.remove('hide');
        infosPanier.classList.remove('hide');
        aucunArticle.classList.add('hide');
        quantiteN.innerHTML = i;
        prixn.innerHTML = Math.round((i*2.99)*100)/100 + "&nbsp;€";
        total.innerHTML = Math.round((i*2.99)*100)/100 + "&nbsp;€"; 
        quantiteFinale.innerHTML = Math.round((iin*2.99)*100)/100 + "&nbsp;€"; 
        let totalsaved = Math.round((i*2.99)*100)/100;
        sessionStorage.setItem('prix', totalsaved);

    }

    //Mot Cadeau 
    let champMot = document.querySelector(".champMot");
    let inputcase = document.querySelector("#check");
    let saved = document.querySelector("#enregistrer");
    saved.addEventListener('click', saving);
    

    inputcase.addEventListener('click', affiche);
    function affiche(){
        champMot.classList.toggle('hide');
        saved.classList.toggle('hide');
    }
    function saving(){
        let Mot = document.querySelector("#motcadeau");
        let motValue = Mot.value;
        sessionStorage.setItem('motcadeau', motValue);
    }

    //Code Promo
    let recapPromo = document.querySelectorAll(".recap__el--promo");
    let codePromo = document.querySelector('#promo');
    
    let appliquerBtn = document.querySelector('#appliquer');
    appliquerBtn.addEventListener('click', application)

    function application(){
    let promoValue = codePromo.value;
    console.log(promoValue);
        if (promoValue == "AfterYang15%"){
            for(let ii = 0; ii < recapPromo.length; ii++){
            recapPromo[ii].classList.remove("hide");
            }

            if(articlePanierPhys=='1' && articlePanierNum=='1'){
                total.innerHTML = Math.round((((iin*2.99)+(iip*13.99))*100)/100) - Math.round(((iin*2.99)+(iip*13.99))*15)/100 + "&nbsp;€";

                let reduc = Math.round(((iin*2.99)+(iip*13.99))*15)/100;
                sessionStorage.setItem('reduction', reduc);

                prixPromo.innerHTML = "-" + Math.round(((iin*2.99)+(iip*13.99))*15)/100 + "&nbsp;€";

             } else if(articlePanierNum == '1') {
                total.innerHTML =  Math.round((iin*2.99)*100)/100 - Math.round((iin*2.99)*15)/100 + "&nbsp;€"; 

                let reduc = Math.round((iin*2.99)*15)/100;
                sessionStorage.setItem('reduction', reduc);

                prixPromo.innerHTML = "-" + Math.round((iin*2.99)*15)/100 + "&nbsp;€"; 

             } else {
                total.innerHTML = Math.round((iip*13.99)*100)/100 - Math.round((iip*13.99)*15)/100 + "&nbsp;€";

                let reduc = Math.round((iip*13.99)*15)/100;
                sessionStorage.setItem('reduction', reduc);

                prixPromo.innerHTML = "-" + Math.round((iip*13.99)*15)/100 + "&nbsp;€"; 

             }
        
        }
    }

    //Supprimer
    let suppBtnN = document.querySelector(".btnsuppN");
    let suppBtnP = document.querySelector(".btnsuppP");
    
    suppBtnN.addEventListener('click', supprimerN);
    suppBtnP.addEventListener('click', supprimerP);

    function supprimerN(){
        let articlePanierNum = sessionStorage.getItem('numerique');
        let articlePanierPhys = sessionStorage.getItem('physique');

        sessionStorage.setItem('numerique', "0");
        sessionStorage.setItem('iin', '1');

        if(articlePanierNum = "0" && articlePanierPhys == "0"){
            produitNum.classList.add('hide');
            infosPanier.classList.add('hide');
            aucunArticle.classList.remove('hide');

        } else {
            produitNum.classList.add('hide');
            infosPanier.classList.remove('hide');
            aucunArticle.classList.add('hide');
        }
    }
    function supprimerP(){
        let articlePanierNum = sessionStorage.getItem('numerique');
        let articlePanierPhys = sessionStorage.getItem('physique');

        sessionStorage.setItem('physique', "0");
        sessionStorage.setItem('iip', '1');

        if(articlePanierPhys = "0" && articlePanierNum == "0"){
        produitPhys.classList.add('hide');
        infosPanier.classList.add('hide');
        aucunArticle.classList.remove('hide');

        } else{
        produitPhys.classList.add('hide');
        infosPanier.classList.remove('hide');
        aucunArticle.classList.add('hide');
        }
    }
}

else if (livraison){
    let clickCase = document.querySelector('#adresseFacturation');
    clickCase.addEventListener('click', show);

    function show(){
        let facturation = document.querySelector('.facturation');
        facturation.classList.toggle('hide');
    }

    let paiement = document.querySelector('#paiement');
    paiement.addEventListener('click', paiementFunction);

    function paiementFunction(){
        if (facturation.classList.contains('hide')){
            let prenoml = document.querySelector('#prenom');
            let noml = document.querySelector('#nom');
            let adressel = document.querySelector('#adresse');
            let codel = document.querySelector('#codepostal');
            let villel = document.querySelector('#ville');
            let paysl = document.querySelector('#pays');

            let prenomlValue = prenoml.value;
            let nomlValue = noml.value;
            let adresselValue = adressel.value;
            let codelValue = codel.value;
            let villelValue = villel.value;
            let payslValue = paysl.value;

            sessionStorage.setItem('prenomliv', prenomlValue);
            sessionStorage.setItem('nomliv', nomlValue);
            sessionStorage.setItem('adresseliv', adresselValue);
            sessionStorage.setItem('codeliv', codelValue);
            sessionStorage.setItem('villeliv', villelValue);
            sessionStorage.setItem('paysliv', payslValue);
 
        } else {
            let prenoml = document.querySelector('#prenom');
            let noml = document.querySelector('#nom');
            let adressel = document.querySelector('#adresse');
            let codel = document.querySelector('#codepostal');
            let villel = document.querySelector('#ville');
            let paysl = document.querySelector('#pays');

            let prenomf = document.querySelector('#prenomf');
            let nomf = document.querySelector('#nomf');
            let adressef = document.querySelector('#adressef');
            let codef = document.querySelector('#codepostalf');
            let villef = document.querySelector('#villef');
            let paysf = document.querySelector('#paysf');

            let prenomlValue = prenoml.value;
            let nomlValue = noml.value;
            let adresselValue = adressel.value;
            let codelValue = codel.value;
            let villelValue = villel.value;
            let payslValue = paysl.value;

            let prenomfValue = prenomf.value;
            let nomfValue = nomf.value;
            let adressefValue = adressef.value;
            let codefValue = codef.value;
            let villefValue = villef.value;
            let paysfValue = paysf.value;



            sessionStorage.setItem('prenomliv', prenomlValue);
            sessionStorage.setItem('nomliv', nomlValue);
            sessionStorage.setItem('adresseliv', adresselValue);
            sessionStorage.setItem('codeliv', codelValue);
            sessionStorage.setItem('villeliv', villelValue);
            sessionStorage.setItem('paysliv', payslValue);

            sessionStorage.setItem('prenomfact', prenomfValue);
            sessionStorage.setItem('nomfact', nomfValue);
            sessionStorage.setItem('adressefact', adressefValue);
            sessionStorage.setItem('codefact', codefValue);
            sessionStorage.setItem('villefact', villefValue);
            sessionStorage.setItem('paysfact', paysfValue);

            
        }
    }
}

else if(paiement){
    let carteBanque = document.querySelector('.cartebanque');
    let carteCredit = document.querySelector('.cartecredit');
    let paypal = document.querySelector('.paypalp');
    let carteBanqueBtn = document.querySelector('#debit');
    let carteCreditBtn = document.querySelector('#credit');
    let paypalBtn = document.querySelector('#paypal');

    carteBanqueBtn.addEventListener('click', affichage);
    carteCreditBtn.addEventListener('click', affichage);
    paypalBtn.addEventListener('click', affichage);

    function affichage(event){
        if (event.currentTarget == carteBanqueBtn){
            carteBanque.classList.remove('hide');
            carteCredit.classList.add('hide');
            paypal.classList.add('hide');

            sessionStorage.setItem('cartebancaire', '1');
            sessionStorage.setItem('paiementpayp', '0');
            sessionStorage.setItem('cartedecredit', '0');


        } else if (event.currentTarget == carteCreditBtn){
            carteBanque.classList.add('hide');
            carteCredit.classList.remove('hide');
            paypal.classList.add('hide');

            sessionStorage.setItem('cartebancaire', '0');
            sessionStorage.setItem('paiementpayp', '0');
            sessionStorage.setItem('cartedecredit', '1');


        } else if (event.currentTarget == paypalBtn){
            carteBanque.classList.add('hide');
            carteCredit.classList.add('hide');
            paypal.classList.remove('hide');

            sessionStorage.setItem('cartebancaire', '0');
            sessionStorage.setItem('paiementpayp', '1');
            sessionStorage.setItem('cartedecredit', '0');

        }
    }
}

else if(recapitulatif){

    let prixN = document.querySelector("#prixN");
    let prixP = document.querySelector("#prixP");
    let sousTotal = document.querySelector('#soustotal');
    let total = document.querySelector('#total');
    let titreP = document.querySelector('#titleP');
    let titreN = document.querySelector('#titleN');
    let motCadeau = document.querySelector('#motcadeau');
    let sectionMot = document.querySelector('#mot');
    let promo = document.querySelectorAll('.promo');
    let promoChiffre = document.querySelector('.promoC');
    let produitP = document.querySelector('.produitpanierP');
    let produitN = document.querySelector('.produitpanierN');

    let iinn= Number(sessionStorage.getItem('iin'));
    let iipp= Number(sessionStorage.getItem('iip'));
    let physique = sessionStorage.getItem('physique');
    let numerique = sessionStorage.getItem('numerique');
    let totall = Number(sessionStorage.getItem('prix'));
    let mot = sessionStorage.getItem('motcadeau');
    let reduct = Number(sessionStorage.getItem('reduction'));
    let q = Number(sessionStorage.getItem('quantite'));


    //code promo - ancien
    if(reduct){
        total.innerHTML = Math.round((totall - reduct + 3.99)*100)/100 + "&nbsp;€";
        sousTotal.innerHTML = totall + "&nbsp;€"; 

        for(let i = 0; i < promo.length; i++){
            promo[i].classList.remove("hide");
        }

        promoChiffre.innerHTML = "-" + reduct + "&nbsp;€";


    } else {
        total.innerHTML = Math.round((totall + 3.99)*100)/100 + "&nbsp;€";
        sousTotal.innerHTML = totall + "&nbsp;€"; 
    }

    //prix articles - prix - recap
    if(physique == '1' && numerique == '1'){
        if (iipp || iinn){
            produitP.classList.remove('hide');
            produitN.classList.remove('hide');

            prixN.innerHTML = iinn*2.99 + "&nbsp;€"
            prixP.innerHTML = iipp*13.99 + "&nbsp;€"

            titreP.innerHTML = "After Yang, Kogonada (" + iipp + ")";
            titreN.innerHTML = "After Yang, Kogonada (" + iinn + ")"; 
        } else {
            produitP.classList.remove('hide');
            produitN.classList.remove('hide');

            prixN.innerHTML = 1*2.99 + "&nbsp;€"
            prixP.innerHTML = 1*13.99 + "&nbsp;€"

            titreP.innerHTML = "After Yang, Kogonada (" + 1 + ")";
            titreN.innerHTML = "After Yang, Kogonada (" + 1 + ")";
        }
        

    } else if (numerique == "1"){
        prixN.innerHTML = q*2.99 + "&nbsp;€"
        titreN.innerHTML = "After Yang, Kogonada (" + q + ")";
        produitN.classList.remove('hide');
        
    } else {
        prixP.innerHTML = q*13.99 + "&nbsp;€"
        titreP.innerHTML = "After Yang, Kogonada (" + q + ")";
        produitP.classList.remove('hide');
    }

    //mot cadeau
    if (mot){
        sectionMot.classList.remove('hide');
        motCadeau.innerHTML = mot;
    }

    //code Promo - nouveau
    let appliquerBtn = document.querySelector('#appliquer');
    appliquerBtn.addEventListener('click', application)
    function application(){
    let inputPromo = document.querySelector('#promo');
    let promoValue = inputPromo.value;
    console.log(promoValue);

        if (promoValue == "AfterYang15%"){
            for(let ii = 0; ii < promo.length; ii++){
            promo[ii].classList.remove("hide");
            }

        total.innerHTML = Math.round(((totall + 3.99)*100)/100) - Math.round(totall*15)/100 + "&nbsp;€";
        promoChiffre.innerHTML = "-" + Math.round((totall*15)/100) + "&nbsp;€";
        }
    }

    //paiement
    let paypal = sessionStorage.getItem("paiementpayp");
    let cardcredit = sessionStorage.getItem('cartedecredit');
    let cardbank = sessionStorage.getItem('cartebancaire');
    let modePaiement = document.querySelector('#modePaiement');

    if(paypal == '1'){
        modePaiement.innerHTML = "Paypal";
    } else if (cardbank == '1'){
        modePaiement.innerHTML = "Carte bancaire";
    } else if(cardcredit == '1'){
        modePaiement.innerHTML = "Carte de crédit";
    }

    //adresse
    let nomLiv = sessionStorage.getItem('nomliv');
    let prenomLiv = sessionStorage.getItem('prenomliv');
    let adresseLiv = sessionStorage.getItem('adresseliv');
    let codeLiv  = sessionStorage.getItem('codeliv');
    let villeLiv = sessionStorage.getItem('villeliv');
    let paysLiv = sessionStorage.getItem('paysliv');

    let nomFact = sessionStorage.getItem('nomfact');
    let prenomFact = sessionStorage.getItem('prenomfact');
    let adresseFact = sessionStorage.getItem('adressefact');
    let codeFact = sessionStorage.getItem('codefact');
    let villeFact = sessionStorage.getItem('villefact');
    let paysFact = sessionStorage.getItem('paysfact');

    let ligne1Liv = document.querySelector('.ligne1liv');
    let ligne2Liv = document.querySelector('.ligne2liv');
    let ligne3Liv = document.querySelector('.ligne3liv');

    let ligne1Fact = document.querySelector('.ligne1fact');
    let ligne2Fact = document.querySelector('.ligne2fact');
    let ligne3Fact = document.querySelector('.ligne3fact');

    if (nomFact){
        ligne1Liv.innerHTML = prenomLiv + " " + nomLiv;
        ligne2Liv.innerHTML = adresseLiv;
        ligne3Liv.innerHTML = villeLiv + " " + codeLiv + " (" + paysLiv +")";

        ligne1Fact.innerHTML = prenomFact + " " + nomFact;
        ligne2Fact.innerHTML = adresseFact;
        ligne3Fact.innerHTML = villeFact + " " + codeFact + " (" + paysFact +")";
    } else {
        ligne1Liv.innerHTML = prenomLiv + " " + nomLiv;
        ligne2Liv.innerHTML = adresseLiv;
        ligne3Liv.innerHTML = villeLiv + " " + codeLiv + " (" + paysLiv +")";

        ligne1Fact.innerHTML = prenomLiv + " " + nomLiv;
        ligne2Fact.innerHTML = adresseLiv;
        ligne3Fact.innerHTML = villeLiv + " " + codeLiv + " (" + paysLiv +")";
    }
}



